module.exports = __webpack_public_path__ + "img/logo.b5c4189d.svg";